import { ConfigProvider } from 'antd';
import { antdTheme } from 'common/theme';
import useAuth from 'common/useAuth';
import { CustomEmpty } from 'components';
import { getAntdLocale } from 'i18n';
import React from 'react';

interface Props {
  children?: React.ReactNode;
}

const AntdProvider: React.FC<Props> = (props): React.ReactElement => {
  const { language } = useAuth();

  return (
    <ConfigProvider
      theme={antdTheme}
      locale={getAntdLocale(language)}
      renderEmpty={() => <CustomEmpty />}
      // remove weird button animation effect
      wave={{ disabled: true }}
    >
      <React.Fragment key={language}>{props.children}</React.Fragment>
    </ConfigProvider>
  );
};

export default AntdProvider;
